<template>
    <div id="PlayerNew">
        <div class="section">
            <h3>New Player</h3>
        </div>
        <div class="section">
          <div class="row">
            <form @submit.prevent="savePlayer" class="col s12">
              <div class="row">
                    <input type="file" @change="uploadImage">
              </div>
              <div class="row">
                <div class="input-field col s12">
                  <input type="text" v-model="playerName" required>
                  <label class="active">Name</label>
                </div>
              </div>
              <div class="row">
                <div class="col s12">
                  <router-link to="/" class="btn grey">Back</router-link>
                  <button type="submit" class="btn green" style="float:right">Save</button>
                </div>
              </div>
            </form>
          </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase'
import db from '../components/firebaseInit';

export default {
  name: 'PlayerNew',
  data() {
    return {
      playerImg: null,
      playerName: null,
    }
  },
  methods: {
    savePlayer() {
      db.collection('players').add({
      playerImg: this.playerImg,
      playerName: this.playerName,
      playerLevelBodyControl: 1,
      playerLevelMentalControl: 1,
      playerLevelTechnique: 1
      })
      .then(docRef => this.$router.push('/'))
      .catch(error => console.log(err))
    },

    uploadImage(event) {

      let file = event.target.files[0];

      // See https://stackoverflow.com/questions/190852/how-can-i-get-file-extensions-with-javascript/1203361#1203361
      var fileExtension = file.name.split('.').pop();

      var storageRef = firebase.storage().ref('spielerbilder/' + Date.now() + '.' + fileExtension);
      // var storageRef = firebase.storage().ref('spielerbilder/' + Date.now() + '_' + this.playerName + '.' + fileExtension);

      let uploadTask = storageRef.put(file);

      uploadTask.on('state_changed', (snapshot) => {

      }, (error) => {
        // Handle unsuccessful uploads
      }, () => {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          // We use the premade firebase extension 'storage-resize-images' Version 0.1.10 to generate thumbnails with max. 550px width || height
          // The file is suffixed like examplefile.jpg -> examplefile_550x550.jpg, this is why we need ThumbnailURL
          // Source: https://stackoverflow.com/questions/10802273/insert-a-string-before-the-extension-in-a-filename
          var ThumbnailURL = downloadURL.substring(0, downloadURL.lastIndexOf(".")) + "_550x550" + downloadURL.substring(downloadURL.lastIndexOf("."));
          this.playerImg = ThumbnailURL;
        });
      });

    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/PlayerNew.vue